import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../context/AuthContext';

export function useWatchlist() {
  const { user, tier } = useAuth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!user) {
      setRows([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    const { data, error } = await supabase
      .from('watchlist')
      .select('*')
      .eq('user_id', user.id)
      .order('created_at', { ascending: false });
    if (error) {
      console.error(error);
      setRows([]);
    } else {
      setRows(data ?? []);
    }
    setLoading(false);
  }, [user]);

  useEffect(() => {
    load();
  }, [load]);

  const isPremium = tier === 'premium';

  const addTicker = useCallback(
    async (stock) => {
      if (!user) return;
      const symbol = stock.symbol?.toUpperCase();
      if (!symbol) return;
      if (rows.some((r) => r.ticker === symbol)) return;
      if (!isPremium && rows.length >= 10) {
        alert('Límite alcanzado');
        return;
      }
      const { error } = await supabase.from('watchlist').insert({
        user_id: user.id,
        ticker: symbol,
      });
      if (error) {
        console.error(error);
        return;
      }
      await load();
    },
    [user, rows, isPremium, load]
  );

  const removeTicker = useCallback(
    async (symbol) => {
      if (!user) return;
      const { error } = await supabase
        .from('watchlist')
        .delete()
        .eq('user_id', user.id)
        .eq('ticker', symbol.toUpperCase());
      if (error) {
        console.error(error);
        return;
      }
      await load();
    },
    [user, load]
  );

  return {
    watchlistRows: rows,
    loading,
    addTicker,
    removeTicker,
    reload: load,
    isPremium,
  };
}
